import { Stack, Typography } from '@mui/material';
import { jsxs, jsx } from 'react/jsx-runtime';

const SectionHeader = props => {
  const {
    children,
    sx,
    variant = 'dimmed',
    disablePadding = false
  } = props;
  const {
    description
  } = props;
  return /*#__PURE__*/jsxs(Stack, {
    direction: "column",
    gap: 0.75,
    sx: {
      py: 1.5,
      px: 2,
      ...(disablePadding && {
        p: 0
      }),
      backgroundColor: theme => variant === 'transparent' ? 'transparent' : theme.palette.background.default,
      ...sx
    },
    children: [/*#__PURE__*/jsx(Typography, {
      variant: "subheader",
      className: "section-header",
      sx: {
        color: theme => theme.palette.text.secondary,
        textTransform: 'uppercase',
        userSelect: 'none'
      },
      children: children
    }), description && /*#__PURE__*/jsx(Typography, {
      children: description
    })]
  });
};

export { SectionHeader };
